import { render, staticRenderFns } from "./IndexLanding.vue?vue&type=template&id=2dd52bb8"
import script from "./IndexLanding.vue?vue&type=script&lang=js"
export * from "./IndexLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports